import React from 'react'
import { Link } from '@inertiajs/react'
import { cx } from '@/lib/utils'
import styles from './PaginationButton.module.scss'

interface PaginationButtonProps {
  href: string
  active?: boolean
  disabled?: boolean
  children: React.ReactNode
}

export const PaginationButton: React.FC<PaginationButtonProps> = ({
  href, active = false, disabled = false, children,
}) => {
  if (disabled) {
    return <span className={cx(styles.btn, styles.disabled)}>{children}</span>
  }

  return (
    <Link href={href} className={cx(styles.btn, active ? styles.active : styles.inactive)}>
      {children}
    </Link>
  )
}
